import { isEqual, mergeWith } from 'lodash';

/**
 * Diffs two objects
 * @param {Record<string, any>} propsDefault     default props
 * @param {Record<string, any>} propsNew         new props
 * @return {Record<string, any>}
 */
export function resolvePropsDif(propsDefault, propsNew) {
    if (propsDefault == null) {
        return propsNew;
    }
    const propsDefaultDif = Object.entries(propsDefault).reduce((acc, [key, valOld]) => {
        const valNew = propsNew[key];
        if (valNew !== null && typeof valNew === 'object' && Array.isArray(valNew) === false) {
            const result = resolvePropsDif(valOld, valNew);
            if (Object.keys(result).length > 0 || valOld == null) {
                return { ...acc, [key]: result };
            }
            return acc;
        }
        if (!Object.hasOwn(propsNew, key)) {
            return { ...acc, [key]: valOld };
        }
        if (valNew === undefined) {
            return acc;
        }
        if (isEqual(valOld, valNew) === false) {
            return { ...acc, [key]: valNew };
        }
        return acc;
    }, {});
    
    const propsNewKeys = Object.keys(propsNew);
    
    if (propsNewKeys.length === 0) {
        return propsDefaultDif;
    }
    
    const propsNewDif = propsNewKeys
        .filter((key) => !Object.hasOwn(propsDefault, key))
        .reduce((acc, key) => ({ ...acc, [key]: propsNew[key] }), {});
    
    return { ...propsDefaultDif, ...propsNewDif };
}

/**
 * Merges two objects
 * @param {Record<string, any>} propsDefault  default props
 * @param {Record<string, any>} props         props
 * @return {Record<string, any>}
 */
export function mergeProps(propsDefault, props) {
    return mergeWith({}, propsDefault, props, (propDefault, propNew) => {
        if (propNew === undefined) {
            return propDefault;
        }
        if (propNew === null) {
            return propNew;
        }
        if (Array.isArray(propNew)) {
            return propNew;
        }
        if (typeof propNew === 'object') {
            return mergeProps(propDefault, propNew);
        }
        return propNew;
    });
}
